import { useState, useEffect } from "react";
import QuotationListPage from "../features/quotation/QuotationListPage";
import QuotationLayout from "../features/quotation/QuotationLayout2026";

export default function QuotationPage({ onNavigate, onboardingContext }) {
  const [view, setView] = useState("list"); // "list" or "editor"
  const [selectedQuotationId, setSelectedQuotationId] = useState(null);
  const [navigationAction, setNavigationAction] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Handle command launcher or onboarding deep-link
  useEffect(() => {
    if (onboardingContext?.action === 'create') {
      handleNavigateToEditor(null, { action: 'create' });
    } else if (onboardingContext?.quotationId) {
      handleNavigateToEditor(onboardingContext.quotationId);
    }
  }, [onboardingContext]);

  const handleNavigateToEditor = (quotationId, options = {}) => {
    setSelectedQuotationId(quotationId);
    setNavigationAction(options.action || null);
    setView("editor");
  };

  const handleNavigateToList = () => {
    setSelectedQuotationId(null);
    setNavigationAction(null);
    setView("list");
    // Trigger list refresh when returning from editor
    setRefreshTrigger((prev) => prev + 1);
  };

  if (view === "editor") {
    return (
      <QuotationLayout
        quotationId={selectedQuotationId}
        initialAction={navigationAction}
        onBack={handleNavigateToList}
        onNavigate={onNavigate}
      />
    );
  }

  return (
    <QuotationListPage
      onNavigateToEditor={handleNavigateToEditor}
      refreshTrigger={refreshTrigger}
      onboardingContext={onboardingContext}
      onNavigate={onNavigate}
    />
  );
}
